/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: clients
 * Page name:
 * Page Description:
 */

import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Image } from "react-bootstrap";
import { Row, Col } from "reactstrap";
import { getImage } from "utils/imageUtilsClient";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Clients(props) {
  const { data } = props;
  return (
    <div>
      <div className="embedded_listdisplay1">
        <Carousel
          className="carouselBorder"
          autoPlay={true}
          responsive={responsive}
          infinite={true}
          autoPlaySpeed={3000}
        >
          {data.data.map((c) => {
            const imageSrc = getImage(c.img);
            return (
              <Row>
                <Col className="center">
                  <Image
                    img
                    src={imageSrc}
                    alt={c.altText}
                    className="homepageclients_techimage"
                  />
                </Col>
              </Row>
            );
          })}
        </Carousel>
      </div>

      <div className="embedded_listdisplay2">
        <Carousel responsive={responsive}>
          {data.data.map((c) => {
            const imageSrc = getImage(c.img);
            return (
              <Image
                img
                src={imageSrc}
                alt={c.altText}
                className="embedded_techimg"
              />
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

export default Clients;
